import { defineStore, acceptHMRUpdate } from "pinia";

export const useContentStore = defineStore("content", {
  persist: true,
  state: () => ({
    content: [],
    contentLoaded: false,
    keysMissing: [],
    keysFound: []
  }),
  actions: {
    addKey(array, key, value = "") {
      // 💡 - TODO
      // When would this be not done? Non-admins? Production?
      //
      if (!this[array].some((item) => item.key === key)) {
        this[array].push({ key, value });
      }
    },
    addKeyMissing(key) {
      this.addKey("keysMissing", key);
    },
    addKeyFound(key, value) {
      this.addKey("keysFound", key, value);
    },
    setContent(content) {
      this.content = content;
      this.contentLoaded = true;
    }
  }
});

// Used in development to keep the store "hot" during HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useContentStore, import.meta.hot));
}
